import {StateProvider as TestStateProvider} from '@components/Test/Context';
import TestManager from '@components/Test/TestManager';
import type {Result, Question, Progress} from '@interfaces/Test';
import type {ReactElement} from 'react';

interface Props {
    id: string;
    type: string;
    showStats: boolean;
    showProgress: boolean;
    progress: Progress;
    questions: Question[];
    results: Result[];
}

export default function Test(props: Props): ReactElement<Props> {
    return (
        <TestStateProvider
            value={{
                id: props.id,
                type: props.type,
                showStats: props.showStats,
                showProgress: props.showProgress,
            }}
        >
            <TestManager
                progress={props.progress}
                questions={props.questions}
                results={props.results}
            />
        </TestStateProvider>
    );
}
